import { PICADA_SELECTED } from "../constants";

export default function (state = null, action) {
  switch (action.type) {
    case PICADA_SELECTED:
      return (action.payload);
    default : return state; 
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/ActiveSelectionReducer.js
 **/


/** WEBPACK FOOTER **
 ** ./src/reducers/ActiveSelectionReducer.js
 **/